import { NgModule } from '@angular/core'
import { StoreModule } from '@ngrx/store'
import { EffectsModule } from '@ngrx/effects'
import { StoreKeysEnum } from '../../../store/store-keys'
import { projectDialogReducer } from './dialog/state/project-dialog.reducers'
import { ProjectDialogEffects } from './dialog/state/project-dialog.effects'
import { projectReducer } from './state/project.reducers'
import { ProjectEffects } from './state/project.effects'

/**
 * Project State Module
 *
 * This module registers NgRx store and effects for Project-related dialogs and features.
 * It's imported globally in AppModule because the dialogs are used across multiple features:
 * - Project edit (admin/project)
 * - Customer edit (admin/customer) - uses project dialogs for cadastral areas
 * - Various project-to-dtsrc components
 *
 * The actual UI components for admin/project are in ProjectModule, which is lazy-loaded.
 */
@NgModule({
    imports: [
        StoreModule.forFeature(StoreKeysEnum.AdminProjectDialog, projectDialogReducer),
        EffectsModule.forFeature([ProjectDialogEffects]),
        StoreModule.forFeature(StoreKeysEnum.AdminProjectFeature, projectReducer),
        EffectsModule.forFeature([ProjectEffects]),
    ],
})
export class ProjectStateModule {}
